// extracted by mini-css-extract-plugin
export var providerSummary1 = "ProviderSummary1-module--providerSummary1--J64kw";
export var contentWrapper = "ProviderSummary1-module--contentWrapper--1JlCh";
export var imageWrapper = "ProviderSummary1-module--imageWrapper--JGMpp";